module.exports = __webpack_public_path__ + "img/banner4.3e89572.jpg";